import { GetterTree } from "vuex";

import { RootState } from "@/store/root-state";

import type { Auth } from "@/models/auth";

export type Getters = {
  token(state: Auth): string;
  login(state: Auth): string;
  sessionTimeout(state: Auth): string;
};

export const getters: GetterTree<Auth, RootState> & Getters = {
  token: (state) => state.token,
  login: (state) => state.login,
  sessionTimeout: (state) => state.sessionTimeout,
};
